
import React from 'react';
const SoundWave = (props: React.SVGProps<SVGSVGElement>) =>
(
    <svg viewBox="0 0 18 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}>
        <path d="M9 7.08325V12.9166" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M12.75 4.58325V15.4166" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M1.5 7.08325V12.9166" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M16.5 7.5V12.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        <path d="M5.25 1.66663V18.3333" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
);


export default SoundWave;






